import React from "react";
import { Link } from "react-router-dom";
import paths from "../../../routes/paths";

function Footer() {
  return (
    <footer
      class="footer footer-center p-10 rounded font-quicksand"
    >
          <p className="text-[#867985] tracking-wider">Copyright © 2023 - All right reserved by LOUVRE </p>
    </footer>
  );
}

export default Footer;
